import { removeUndefined } from '@helpers/object';

/**
 * @typedef {Object} ConversionToolMappingsApiData
 * @property {string} id user id
 * @property {string} name mapping name
 * @property {string} vatNumber vat number
 * @property {string} filingType filing type id
 * @property {string} headerStart header start number
 */

/**
 * @typedef ConversionToolSettingsListItem
 * @prop {string} id Unique identifier
 * @prop {string} name Mapping name
 * @prop {string} filingType Filing type name
 */

/**
 * Transforms mapping list from API data
 * @param {Array<ConversionToolMappingsApiData>} data - Mappings from API
 * @param {Array<FilingTypesApiData>} [filingTypes=[]] - Filing types from API
 * @returns {Array<ConversionToolSettingsListItem>} Conversion tool settings data model.
 */
export const conversionToolMappingsList = (data, filingTypes = []) =>
  data.map(({ id, name, filingType }) =>
    removeUndefined({
      id,
      name,
      filingType: filingTypes.find(type => type?.periodDetail?.filingType?.id === filingType)
        ?.periodDetail?.filingType?.nameLong,
    })
  );
